 import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {setJumbotronTitle} from '../../actions/common'
import {buildUrlFromParams} from '../common/functions/url'
import {takeExcelFile} from '../common/functions/excelExport'
import WithAjax from '../common/helpers/WithAjax'
import WithNotify from '../common/helpers/WithNotify'
import MultiSelect from '../common/form/MultiSelect'
import {validateField} from '../../actions/helpers/validation'
import {getCountryNames, getSelectedCountryCode} from '../common/functions/countrySetting'
import {
  validateTalentExportField,
  setTalentExportDropdownOptions,
  clearTalentExportFields
} from '../../actions/pages/talent-export-page'



class TalentExport extends Component {
  constructor(){
    super();

    this.exportData = this.exportData.bind(this)

    this.state = {
      stausForExport: '',
      countryNamesForExport: ''
    }
  }

  componentDidMount() {
    this.props.setJumbotronTitle('Talent export');
  }

  getFieldValue(fieldName) {
    var field = this.props.fields.find((el) => {
      return el.name === fieldName;
    });

    return field.value;
  }

  exportData(event){
    event.preventDefault();

    let validatedFields = this.props.fields.map(field => validateField(field));
    let isValid =
        validatedFields.filter(field => field.errors.length > 0).length > 0
        ? false
        : true;

    if (!isValid){
        return;
    }

    var countryNamesValue = this.getFieldValue('CountryName');
    var statusNameValue = this.getFieldValue('StatusName');

    var countryNamesValueArr = countryNamesValue.split(',');
    var statusNameValueArr = statusNameValue.split(',');

    var countriesAmount = getCountryNames().length;
    
    let url = buildUrlFromParams(
      'skillVendors/exportall',
      {
        noi18n: 'true',
        countries: countryNamesValueArr.length == countriesAmount ? '' : countryNamesValue,
        statuses: statusNameValueArr.length == 3 ? '' : statusNameValue
      });

    this.props.ajax.get(url, true, (data) => {
      takeExcelFile(data);
    });

  }

  render() {
    let fields = this.props.fields;

    return (
      <form onSubmit={e => e.preventDefault()}>
        <div className="row">
          <div className="col-4">
            <MultiSelect field={fields[1]} validate={this.props.validateTalentExportField} />
          </div>
          <div className="col-4">
            <MultiSelect field={fields[0]} validate={this.props.validateTalentExportField} />
          </div>
          <div className="col-4">
            <button
              className="btn btn-primary btn-rounded mt-4"
                type="submit"
              onClick={this.exportData}>
              Export
            </button>
          </div>
        </div>
      </form>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  fields: state.talentExportPage.fields
})
const mapDispatchToProps = dispatch => ({
  setJumbotronTitle(title) { dispatch(setJumbotronTitle(title)) },
  validateTalentExportField(value, field) { dispatch(validateTalentExportField(value, field)) },
  setTalentExportDropdownOptions(countryNames, statuses) { dispatch(setTalentExportDropdownOptions(countryNames, statuses)) },
  clearTalentExportFields() { dispatch(clearTalentExportFields()) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(TalentExport))
